import React, { createContext, useState, useContext, useEffect } from "react";
import axios from "axios";
import { getToken } from "../utils/tokenUtils";

// Create context
const NotificationsContext = createContext();

// Provider component
export const NotificationsProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const API_BASE = "https://hrmsnew.prepstripe.com/api";
  const token = getToken();

  // Fetch notifications
  const fetchNotifications = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(`${API_BASE}/notifications`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      // Correcting the response structure
      const responseData = response.data.Notifications;
      setNotifications(responseData || []);
    } catch (err) {
      setError("Failed to fetch notifications.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // Send notification to a user
  const sendNotification = async (sendNotificationData) => {
    try {
      const response = await axios.post(
        `${API_BASE}/notifications/send`,
        sendNotificationData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      alert(response.data.success);
      return response.data.success;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Failed to send notification.",
      );
    }
  };

  // Mark notification as read
  const readNotification = async (readNotificationData) => {
    try {
      const response = await axios.post(
        `${API_BASE}/notifications/read`,
        readNotificationData,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      // alert("Notification marked as read.");
      fetchNotifications(); // Refresh the notifications
      return response.data.success;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Failed to mark notification as read.",
      );
    }
  };

  // Read all notifications
  const readAllNotification = async () => {
    // console.log("token in readAllNotification: ", token)
    try {
      await axios.post(
        `${API_BASE}/notifications/read-all`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      // alert("Notification marked as read.");
      fetchNotifications(); // Refresh the notifications
      // return response.data.success;
    } catch (err) {
      throw new Error(
        err.response?.data?.message || "Failed to mark notification as read.",
      );
    }
  };

  // Delete a notification
  const deleteNotification = async (id) => {
    try {
      await axios.delete(`${API_BASE}/notifications/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // alert("Notification deleted.");
      fetchNotifications(); // Refresh after deletion
    } catch (err) {
      throw new Error("Failed to delete notification.");
    }
  };

  // **Add New Notification (For Laravel Echo Real-time Updates)**
  const addNotification = (notification) => {
    setNotifications((prevNotifications) => [
      notification,
      ...prevNotifications,
    ]);
  };

  // // Read Notification
  // const readNotification = async ({ notification_id }) => {
  //     try {
  //     await axios.post(`/notifications/read/${notification_id}`);
  //     setNotifications((prev) => prev.filter((n) => n.id !== notification_id));
  //     } catch (error) {
  //     console.error("Error marking notification as read:", error);
  //     }
  // };

  useEffect(() => {
    fetchNotifications(); // Fetch notifications on mount
  }, []);

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        loading,
        error,
        addNotification,
        fetchNotifications,
        sendNotification,
        readNotification,
        deleteNotification,
        readAllNotification,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
};

// Custom hook for using context
export const useNotifications = () => {
  return useContext(NotificationsContext);
};
